module.exports = __webpack_public_path__ + "h5/img/404.c67ac50c.png";